
export const URLS = {
	InitialIssuanceImportTemplate: process.env.VUE_APP_siteUrl + '/Template/Initial%20Issuance%20Import%20Template.xlsx',
	DirectInvestmentExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Direct%20Investment%20Import%20Template.xlsx',
	DistributionExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Distribution%20Event%20Import%20Template.xlsx',
	IssuanceExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Issuance%20Event%20Import%20Template.xlsx',
	ProgramInformationImportTemplate: process.env.VUE_APP_siteUrl + '/Template/Program%20Information%20Import%20Template.xlsx',
	CustomFootnoteExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Custom%20Footnote%20Template.xlsx',
	VestingEventImportTemplate: process.env.VUE_APP_siteUrl + '/Template/Vesting%20Event%20Import%20Template.xlsx',
	InvestmentValuationExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Investment%20Valuation%20Template.xlsx',
	InvestmentExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Investment%20Template.xlsx',
	TransferExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Transfer%20Event%20Import%20Template.xlsx',
	PartnerInfoExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Partner%20Template.xlsx',
	InfoTrackerExcelTemplate: process.env.VUE_APP_siteUrl + '/Template/Information%20Tracker%20Template.xlsx',
}

export let baseUrl = process.env.VUE_APP_siteUrl;
export let templatePath = process.env.VUE_APP_TemplatePath;

export let templates = new Map();
templates.set('ProgramInformationImport', 'Program%20Information%20Import%20Template.xlsx')
templates.set('InitialIssuanceImport', 'Initial%20Issuance%20Import%20Template.xlsx')
templates.set('DirectInvestmentExcel', 'Direct%20Investment%20Import%20Template.xlsx')
templates.set('DistributionExcel', 'Distribution%20Event%20Import%20Template.xlsx')
templates.set('IssuanceExcel', 'Issuance%20Event%20Import%20Template.xlsx')
templates.set('CustomFootnoteExcel', 'Custom%20Footnote%20Template.xlsx')
templates.set('VestingEventImport', 'Vesting%20Event%20Import%20Template.xlsx')
templates.set('InvestmentValuation', 'Investment%20Valuation%20Template.xlsx')
templates.set('InvestmentExcel', 'Investment%20Template.xlsx')
templates.set('TransferExcel', 'Transfer%20Event%20Import%20Template.xlsx')
templates.set('PartnerInfoExcel', 'Partner%20Template.xlsx')
templates.set('InfoTrackerExcel', 'Information%20Tracker%20Template.xlsx')

export function getFileName(templateName){
	console.log('getFileName.....' + templateName)
	return templates.get(templateName);
}

export function getUrl(templateName) {
	console.log('getUrl.....' + templateName)
	return baseUrl + templatePath + templates.get(templateName)

}

